// Benepack OMS · MainLayout (WF-02)
// 严格按 wireframes §2 ASCII:
//   ┌─[ Topbar 56px · #FFFFFF ]──────────┐
//   │ LOGO + 面包屑          通知/语言/用户  │
//   ├─Sidebar 200px #001529──┼─Content #F5F7FA─┤
//   │ Menu inline dark        │ 20-24px padding  │
//   └────────────────────────┴────────────────┘
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { PendingApprovalsProvider } from '@/hooks/usePendingApprovals';

const { Content } = Layout;

export function MainLayout() {
  const [collapsed, setCollapsed] = useState(false);
  return (
    // 待审批提醒单轮询挂在此 (Topbar 铃铛 / Sidebar 徽标 / 工作台卡 三面共享 · 不 3× poll · go-live 反馈 #3)。
    <PendingApprovalsProvider>
      <Layout style={{ minHeight: '100vh' }}>
        <Sidebar collapsed={collapsed} onCollapse={setCollapsed} />
        <Layout>
          <Topbar />
          <Content style={{ margin: 0, padding: 20, background: '#F5F7FA' }}>
            <div style={{ maxWidth: 1680, margin: '0 auto' }}>
              <Outlet />
            </div>
          </Content>
        </Layout>
      </Layout>
    </PendingApprovalsProvider>
  );
}

export default MainLayout;
